<template>
  <div class="validation_request_order_suborders_options" v-if="options && options.length">
    <h5>Options</h5>
    <ul  class="validation_request_order_suborders_options_list">
      <li class="validation_request_order_suborders_options_list_item" v-for="(option, index) in options" :keys="'option-' + index">
        <div>
          <div style="display:inline-block;margin-left:auto;margin-right:0px;"><h5>{{option.name}}</h5></div>
          <!-- <price :default_price="option.default_price" :default_price_list="option.default_price_list">
          </price> -->
        </div>
        <!-- <div v-if="option.help"></option>
          <p>{{option.help}}</p>
        </div> -->
      </li>
    </ul>
  </div>
  <!-- <div v-else class="validation_request_order_suborders_options">
    <h5>Sans options</h5>
  </div> -->
</template>
<script>
import Price from "../Offer/Price"
export default {
  name:"ValidationRequestableOrderSubordersOptions",
  props:["options"],
  components:{
    Price,
  },
}
</script>
<style scoped>
.validation_request_order_suborders_options {
  padding-left: 15px;
  padding-right: 15px;
  border-right: solid 1px lightgrey;
  width:50%;
}

.validation_request_order_suborders_options_list {

}

.validation_request_order_suborders_options_list_item {
  border-top: solid 1px lightgray;
}

@media screen and (max-width: 1200px) {
  .validation_request_order_suborders_options {
    border-right: 0;
  }
}

</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Order/Options.vue